import React from 'react';

export const EnergyProfLogo = ({ width = '18', height = '18', fill = 'var(--icon-color-base)' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1263_3865)">
        <path
          d="M1.5 7.5C2.08476 4.63807 4.25189 2.34699 7.05463 1.56733C7.2899 1.50188 7.40753 1.46916 7.47089 1.53927C7.53427 1.60938 7.48758 1.72531 7.39423 1.95717L6.75 3.375M10.5 1.5C13.3619 2.08476 15.653 4.25189 16.4326 7.05463C16.4981 7.2899 16.5308 7.40753 16.4607 7.47089C16.3906 7.53427 16.2747 7.48758 16.0428 7.39423L14.625 6.75M16.5 10.5C15.9152 13.3619 13.7481 15.653 10.9453 16.4326C10.7101 16.4981 10.5925 16.5308 10.5291 16.4607C10.4657 16.3906 10.5124 16.2747 10.6057 16.0428L11.25 14.625M7.5 16.5C4.63807 15.9152 2.34699 13.7481 1.56733 10.9453C1.50188 10.7101 1.46916 10.5925 1.53927 10.5291C1.60938 10.4657 1.72531 10.5124 1.95717 10.6057L3.375 11.25"
          stroke={fill}
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M6.45966 8.74852L9.084 5.37994C9.28927 5.11649 9.67395 5.28046 9.67395 5.6314V8.23875C9.67395 8.44897 9.82485 8.61937 10.0109 8.61937H11.2873C11.5773 8.61937 11.7319 9.00555 11.5403 9.25147L8.916 12.62C8.71072 12.8835 8.32605 12.7195 8.32605 12.3686V9.76125C8.32605 9.55102 8.17515 9.38062 7.98907 9.38062H6.71263C6.42267 9.38062 6.2681 8.99445 6.45966 8.74852Z"
          stroke={fill}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1263_3865">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
